<template>
  <div class="green-page">
    <div class="green-card">
      <div class="green-icon-wrap">
        <svg class="green-icon" viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="#4caf50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <h2 class="green-title">绿色通道</h2>
      <p class="green-desc">输入验证密码后，可跳过浏览器兼容性校验直接进入系统</p>

      <form class="green-form" @submit.prevent="submit">
        <input
          v-model="password"
          class="green-input"
          type="password"
          placeholder="请输入验证密码"
          autocomplete="off"
        />
        <button class="green-btn" type="submit" :disabled="loading">
          {{ loading ? "验证中..." : "进入系统" }}
        </button>
      </form>
      <div v-if="errorMsg" class="green-error">{{ errorMsg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GreenChannel",
  data() {
    return {
      password: "",
      errorMsg: "",
      loading: false
    };
  },
  methods: {
    submit() {
      if (this.loading) return;
      const PASSWORD = "7264913058";
      if (!this.password) {
        this.errorMsg = "请输入验证密码";
        return;
      }
      if (this.password !== PASSWORD) {
        this.errorMsg = "密码错误，请重试";
        return;
      }
      this.loading = true;
      this.errorMsg = "";
      localStorage.setItem("greenChannelAccess", "1");
      this.$router.replace("/");
    }
  }
};
</script>

<style scoped>
.green-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
}

.green-card {
  background: #fff;
  border-radius: 16px;
  padding: 36px 32px 28px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.green-icon-wrap {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  background: #e8f5e9;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.green-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 8px;
}

.green-desc {
  font-size: 13px;
  color: #888;
  line-height: 1.6;
  margin: 0 0 24px;
}

.green-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.green-input {
  width: 100%;
  box-sizing: border-box;
  height: 44px;
  border: 1px solid #e3e8f0;
  border-radius: 10px;
  padding: 0 14px;
  font-size: 14px;
  color: #333;
  outline: none;
  transition: border-color 0.2s;
}

.green-input:focus {
  border-color: #4caf50;
}

.green-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: #4caf50;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}

.green-btn:hover {
  background: #43a047;
}

.green-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.green-error {
  margin-top: 14px;
  font-size: 13px;
  color: #e53935;
}
</style>
